module.exports = __webpack_public_path__ + "static/tablet.03dc3289.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/tablet.png
// module id = 601
// module chunks = 54681204059826